import { FC } from "react";

import dynamic from "next/dynamic";

import { EmailRecipientsChipListProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
export const EmailRecipientsChipList = dynamic(
  () => import("./EmailRecipientsChipListSsr").then((mod) => mod.EmailRecipientsChipListSsr),
  {
    ssr: false,
  }
) as FC<EmailRecipientsChipListProps>;
